export default "__VITE_ASSET__1800d82c__"